module.exports = __webpack_public_path__ + "static/img/activity2.941d6ab0.png";